export default __webpack_public_path__ + "static/media/minus.5a6945f6.svg";